import AuthErrorView from './AuthErrorView';
import { useAuth0 } from '@auth0/auth0-react';
import { useURLSearchParams } from 'utils/hooks';

function AuthError() {
    const params = useURLSearchParams();
    const { loginWithRedirect } = useAuth0();
    const error = new Error();
    error.error = params.get('error');
    error.message = params.get('error_description');
    error.tracking = params.get('tracking');
    error.client_id = params.get('client_id');
    error.connection = params.get('connection');

    return (
        <AuthErrorView error={error} loginWithRedirect={loginWithRedirect} />
    );
}

export default AuthError;
